(function () {
  const replacements = {
    "Calculate My Size": "Descubra meu tamanho",
    "Size Chart": "Tabela de medidas",
    "We recommend the size:": "Tamanho recomendado:",
    "See other sizes:": "Ver outros tamanhos:",
    "TIGHT": "JUSTO",
    "LOOSE": "SOLTO",
    "Regular": "Regular",
    "Loose": "Solto"
  };

  function translateText(root) {
    if (!root) return;

    root.querySelectorAll("*").forEach(function (el) {
      if (el.children.length > 0) return;

      const text = el.textContent.trim();
      if (replacements[text]) {
        el.textContent = replacements[text];
      }
    });
  }

  function findKiwiContainers() {
    return document.querySelectorAll(
      '[class*="kiwi"], [id*="kiwi"], [class*="ksc"], [id*="ksc"], [class*="size-chart"], [id*="size-chart"]'
    );
  }

  function runKiwiTranslation() {
    findKiwiContainers().forEach(translateText);
  }

  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(runKiwiTranslation, 1500);
    setTimeout(runKiwiTranslation, 3000);
  });

  document.addEventListener("click", function () {
    setTimeout(runKiwiTranslation, 500);
    setTimeout(runKiwiTranslation, 1200);
  });
})();